import OfferMessage from './OfferMessage'

export default OfferMessage
